import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PressureTemperatureTableViewModel } from '../../shared/models/autogenerated-piping';

// Interface para el resultado de validación - usar el modelo ya existente
export interface PressureTemperatureTableValidationResult {
  isCurrent: boolean;
  latestVersion?: PressureTemperatureTableViewModel;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PTTSyncService {
  private baseUrl = environment.pipingApiEndpoint;

  constructor(private http: HttpClient) {}

  /**
   * Valida si una PTT es la más reciente y devuelve la última versión si no lo es
   * @param tableId ID de la tabla a validar
   */
  validateAndGetLatestPTT(tableId: string): Observable<PressureTemperatureTableValidationResult> {
    const url = `${this.baseUrl}/PressureTemperatureTable/ValidateAndGetLatest/${tableId}`;
    return this.http.get<PressureTemperatureTableValidationResult>(url);
  }

  /**
   * Obtiene la última versión de una PTT por nombre
   * @param tableName Nombre de la tabla
   */
  validateAndGetLatestPTTByName(tableName: string): Observable<PressureTemperatureTableValidationResult> {
    const url = `${this.baseUrl}/PressureTemperatureTable/ValidateAndGetLatestByName/${encodeURIComponent(tableName)}`;
    return this.http.get<PressureTemperatureTableValidationResult>(url);
  }
}
